import axios from 'axios' //引入
import { getToken } from '@/util/getToken'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_API,
  // 超时
  timeout: 120000,
})

/* 请求拦截器（请求之前的操作） */
service.interceptors.request.use(
  (config) => {
    //如果有需要在这里开启请求时的loading动画效果
    config.headers.Authorization = 'Bearer ' + getToken() //添加token,需要结合自己的实际情况添加，
    return config
  },
  (err) => Promise.reject(err)
)

export default service
